import {
  MapDataFile_Create_Request,
  MapDataFile_Create_Response,
  MapDataFile_Delete_Response,
  MapDataFile_Update_Request,
  MapDataFile_Update_Response,
} from '../models/MapDataFile';
import { getAxiosInstance } from '../../react/utils/networkUtil';
import { Mbtiles_Info } from '../models/Mbtiles';
import { MapDataLayer_Style } from '../models/MapDataLayer';

/**
 * explicit declare response type
 * @param path
 * @returns
 */
export const remote_mapDataFile_getInfo = async (path: string): Promise<Mbtiles_Info> => {
  try {
    const response = await getAxiosInstance().get(`/api/map-data-file-ext/info?path=${path}`);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapDataFile_create');
    throw e;
  }
};

export const remote_mapDataFile_getContent = async (name: string, id: number): Promise<MapDataLayer_Style> => {
  try {
    const response = await getAxiosInstance().get(`/api/map-data-file-ext/download?filename=${name}&mapDataFileId=${id}`);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapDataFile_create');
    throw e;
  }
};

export const remote_mapDataFile_create = async (
  createRequest: MapDataFile_Create_Request,
): Promise<MapDataFile_Create_Response> => {
  try {
    const response = await getAxiosInstance().post('/api/map-data-file-ext', createRequest);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapDataFile_create');
    throw e;
  }
};

export const remote_mapDataFile_update = async (
  id: number,
  updateResponse: MapDataFile_Update_Request,
): Promise<MapDataFile_Update_Response> => {
  try {
    const response = await getAxiosInstance().put(`/api/map-data-file-ext/${id}`, updateResponse);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapDataFile_create');
    throw e;
  }
};

export const remote_mapDataFile_delete = async (id: number): Promise<MapDataFile_Delete_Response> => {
  try {
    const response = await getAxiosInstance().delete(`/api/map-data-file-ext/${id}`);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_mapDataFile_delete');
    throw e;
  }
};

export const MapDataFileAPIs = {
  remote_mapDataFile_getInfo,
  remote_mapDataFile_getContent,
  remote_mapDataFile_create,
  remote_mapDataFile_update,
  remote_mapDataFile_delete,
};
